import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getNewsDetailsById } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const NewsDetails = ({ id }) => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.profileReducer);
  const [serviceData, setServiceData] = useState(null);
  const toast = useRef(null);
  // const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getNewsManagement = async () => {
    setIsLoading(true);
    getNewsDetailsById(id, token)
      .then((res) => {
        setServiceData(res?.data?.data);
        setIsLoading(false);
        if (res) {
          setServiceData(res?.data?.data);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    async function getAllAPI() {
      await getNewsManagement();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditHandler = () => {
    navigate(`/news-management/editNews?newsId=${id}`);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="news-details-cls-portion">
        {isLoading && (
          <div className="set-proper-line-in-all-page">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <div className="event-details-all-starting-part">
          <div className="userprofile-pics">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">News Details</h6>
              </div>
              <div className="right-side-btn-add d-flex align-items-center event-details-btn-cls">
                <button
                  className="btn btn-primary edit-btn-cls"
                  onClick={() => onEditHandler()}
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="news-details-all body-part-area-start-profile styling-portion-add mt-4">
          <div className="row align-items-start">
            <div className="col-lg-3">
              <div className="left-side-img">
                <img
                  className="news-details-img"
                  src={
                    serviceData?.image
                      ? serviceData?.image
                      : require("../../assets/defaultnews.png")
                  }
                  alt="land"
                />
              </div>
            </div>
            <div className="col-lg-9">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Title</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {serviceData?.title ? serviceData?.title : "-"}
                      </h6>
                    </div>
                  </div>
                  <div className="title-name">
                    <label>Link</label>
                    <div className="subtitle-names">
                      {/* <h6 className="mb-0"> */}
                      {serviceData?.link ? (
                        <a href={serviceData?.link}>{serviceData?.link}</a>
                      ) : (
                        <p>-</p>
                      )}

                      {/* </h6> */}
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Content</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {serviceData?.content ? serviceData?.content : "-"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsDetails;
